// extracted by mini-css-extract-plugin
module.exports = {"error":"style__error__WeZNL","buttonArea":"style__buttonArea__coVxz"};